import React, { useEffect, useState } from 'react';

export default function Preloader() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 700);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return <div className="preloader" style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.5s' }}></div>;
}
